<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">微信聊天</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">自动回复管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addstatus" type="primary">添加自动回复</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除自动回复</a-button>
            </div>
            <!-- 搜索 --> 

            <div class="right">
                <a-input-search
                    placeholder="请输入"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
        </div>
        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" rowKey="arid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    
                    <span slot="action" slot-scope="text,record" class="operate">
                        <a href="javascript:;" @click="edituser(record.arid)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.arid)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="type" slot-scope="text"> 
                        <span v-if="text==1">关注自动回复</span>
                        <span v-if="text==2">关键字回复</span>
                        <span v-if="text==3">人工服务</span>
                        <span v-if="text==4">点击事件回复</span>
                    </span>

                    <span slot="text" slot-scope="text"> 
                        <span v-if="text==1">文本消息</span>
                        <span v-if="text==2">图片消息</span>
                    </span>

                    <span slot="video" >
                        <!-- <video :src="text"></video> -->
                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

         <!-- 添加自动回复 -->
        <a-modal
        title="添加自动回复"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="名称">
                    <a-input v-model="title" placeholder="请输入自动回复名称" v-decorator="['自动回复名称', { rules: [{ required: true, message: '请输入自动回复名称' }] }]"/>
                </a-form-item>
                <a-form-item label="回复类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="type" allowClear @change="typehandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="keyshow" label="关键字">
                    <a-input v-model="keyword" placeholder="关键字" auto-size/>
                </a-form-item>
                 <!-- <a-form-item v-if="clickshow" label="点击事件">
                     <a-select style="width: 120px;margin-left:12px" v-model="keyword" allowClear @change="clickhandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in clickoption" :key="x" :value="option.title">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item> -->
                <a-form-item label="回复内容">
                    <a-textarea  v-model="content" placeholder="回复内容" rows="6"/>
                </a-form-item>
                <a-form-item label="文本类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="MsgType" allowClear @change="texthandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in textoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="textshow" label="素材接口">
                    <!-- <a-input v-model="media_id" placeholder="图片地址"/> -->
                    <a-select style="width: 120px;margin-left:12px" v-model="media_id" allowClear @change="imghandleChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in imgoption" :key="x" :value="option.media_id">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="sort" placeholder="数字越小越靠前"/>
                </a-form-item>
                
            </a-form>
        </a-modal>

        <!-- 编辑自动回复 -->
        <a-modal
        title="编辑自动回复"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                 <a-form-item label="名称">
                    <a-input v-model="editinfo.title" placeholder="请输入自动回复名称" v-decorator="['自动回复名称', { rules: [{ required: true, message: '请输入自动回复名称' }] }]"/>
                </a-form-item>
                <a-form-item label="回复类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="editinfo.type" allowClear @change="typeeditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="keyshow" label="关键字">
                    <a-input v-model="editinfo.keyword" placeholder="关键字"/>
                </a-form-item>
                <!-- <a-form-item v-if="clickshow" label="点击事件">
                     <a-select style="width: 120px;margin-left:12px" v-model="editinfo.keyword" allowClear @change="clickeditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in clickoption" :key="x" :value="option.title">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item> -->
                <a-form-item label="回复内容">
                    <a-textarea  v-model="editinfo.content"  rows="6" placeholder="回复内容" auto-size/>
                </a-form-item>
                <a-form-item label="文本类型">
                    <a-select style="width: 120px;margin-left:12px" v-model="editinfo.MsgType" allowClear @change="texteditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in textoption" :key="x" :value="option.id">
                            {{option.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item v-if="textshow" label="素材接口">
                    <!-- <a-input  v-model="media_id" placeholder="图片地址"/> -->
                    <a-select style="width: 120px;margin-left:12px" v-model="editinfo.media_id" allowClear @change="imgeditChange" placeholder="动作类型" :showArrow="show">
                        <a-select-option v-for="(option,x) in imgoption" :key="x" :value="option.media_id">
                            {{option.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="排序">
                    <a-input v-model="editinfo.sort" placeholder="数字越小越靠前"/>
                </a-form-item>

            </a-form>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'arid',key: 'arid',width:80},
    {title: '名称',dataIndex: 'title',key: 'title',width:140},
    {title: '回复类型',dataIndex: 'type',key: 'type',scopedSlots: { customRender: 'type' },width:140},
    {title: '关键字',dataIndex: 'keyword',key: 'keyword',width:80},
    {title: '回复内容',dataIndex: 'content',key: 'content',width:240},
    {title: '文本类型',dataIndex: 'MsgType',key: 'MsgType',scopedSlots: { customRender: 'text' },width:140},
    {title: '素材接口',dataIndex: 'media_id',key: 'media_id',width:140},
    {title: '排序',dataIndex: 'sort',key: 'sort',width:80},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' },width:140},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },width:160,fixed: 'right'},
]
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,
            tablex:'100%',

            imid:"",
            title:"",
            type:"",
            keyword:"",
            content:"",
            sort:"",
            MsgType:"",
            media_id:"",

            sort:"",
            status:1,
            editinfo:{type:'',MsgType:'',media_id:""},
            editid:"",
            disabled:true,
            delids:"",
            true:true,
            false:false,
            keyshow:false,
            textshow:false,
            clickshow:false,
            clickoption:[],

            searchtext:"",
            imgoption:"",

            imid:"",
            typeoption:[{id:"1",name:"关注自动回复"},{id:"2",name:"关键字回复"},{id:"3",name:"人工服务"},{id:"4",name:"点击事件回复"},{id:"5",name:"常见问题列表"}],
            textoption:[{id:"1",name:"文本消息"},{id:"2",name:"图片消息"}]
        }
    },
    watch: {
      windowHeight (val) {
        this.tablex=val-300
      },
    },
    mounted(){
        this.fetch()
        this.personinfo()
        // this.getclicklist()
        window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{
        imgeditChange(value){
            this.editinfo.media_id=value
        },
        imghandleChange(value){
            this.media_id=value
        },

        getimglit(){
             this.$axios.post('/api/wechat/setguideimagematerialuploadlist',{
                pagesize: 30,
                imid:this.imid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.imgoption=res.data.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // getclicklist(){
        //     this.$axios.post('/api/wechat1/autoreplylist',{
        //         pagesize: 50,
        //         type:4
        //     },{
        //         headers: {
        //             "token":localStorage.getItem('token'),
        //         }
        //     }).then((res)=>{
        //         if(res.data.code==200){
        //            this.clickoption=re.data.data.data
        //         }else{
        //             this.$message.warning(res.data.msg); 
        //         }
               
        //     })
        // },
        personinfo(){
        this.$axios.post('/api/system/adminpage',{
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.imid=res.data.data.imid
                    this.getimglit()
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },

        // 回复类型
        typehandleChange(value){
            this.type=value
            if(value==2||value==3){
                this.keyshow=true
                this.clickshow=false
            }else{
                this.keyshow=false
                this.clickshow=false
            }
        },

        texthandleChange(value){
            this.MsgType=value
            if(value==2){
                this.textshow=true
            }else{
                this.textshow=false
            }
        },
        typeeditChange(value){
            this.editinfo.type=value
            if(value==2||value==3){
                this.keyshow=true
                this.clickshow=false
            }else{
                this.keyshow=false
                this.clickshow=false
            }
        },
        clickeditChange(value){
            this.editinfo.keyword=value
        },
        texteditChange(value){
            this.editinfo.MsgType=value
            if(value==2){
                this.textshow=true
            }else{
                this.textshow=false
            }
        },
        handleCancel(){
            this.addvisible=false,
            this.editvisible=false
        },

        // 是否显示
        onstatusChange(checked,id){
            console.log(checked)
            console.log(id)
            var status;
            if(checked){
                status=1
            }else{
                status=-1
            }
            this.$axios.post('/api/user/edituserrank',{
                arid:id,
                status:status
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        onChange(checked){
            if(checked){
                this.status=1
            }else{
                this.status=-1
            }
        },
        oneditChange(checked){
             if(checked){
                this.editinfo.status=1
            }else{
                this.editinfo.status=-1
            }
        },


         // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/wechat1/delautoreply',{
                arids:id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 编辑自动回复
        edituser(id){
            this.editid=id
            this.$axios.post('/api/wechat1/autoreplypage',{
                arid:id,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=true
                    this.editinfo=res.data.data
                    if(res.data.data.MsgType==2){
                        this.textshow=true
                    }else{
                        this.textshow=false
                    }
                    if(res.data.data.type==2||res.data.data.type==3){
                        this.keyshow=true
                    }else{
                        this.keyshow=false
                    }
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        edithandleOk(){
            this.$axios.post('/api/wechat1/editautoreply',{
                arid:this.editid,
                // imid:this.editinfo.imid,
                title:this.editinfo.title,
                type:this.editinfo.type,
                keyword:this.editinfo.keyword,
                content:this.editinfo.content,
                sort:this.editinfo.sort,
                MsgType:this.editinfo.MsgType,
                media_id:this.editinfo.media_id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.$message.success('编辑成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 添加自动回复
        addstatus(){
            this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/wechat1/addautoreply',{
                imid:this.imid,
                title:this.title,
                type:this.type,
                keyword:this.keyword,
                content:this.content,
                sort:this.sort,
                MsgType:this.MsgType,
                media_id:this.media_id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.title=""
                    this.type=""
                    this.keyword=""
                    this.content=""
                    this.sort=""
                    this.MsgType=""
                    this.$message.success('添加成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },
        // 搜索
        onSearch(){
            this.fetch()
        },
        // 数据
        fetch(params = {}){
            this.$axios.post('/api/wechat1/autoreplylist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    var data=res.data.data.data
                    for(var i in data){
                        if(data[i].status==-1){
                            data[i].status=false
                        }else{
                            data[i].status=true
                        }
                    }
                    this.data=data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/chat/reply.vue